import React, {Component} from 'react';
import LinkConfirmDelete from './LinkConfirmDelete'

class AccountLinnkDelete extends Component {
  render() {
    const {account, onDelete} = this.props
    const content = `Chắc chắn xoá tài khoản ${account.UserName}?`
    return <LinkConfirmDelete title="Xoá tài khoản" content={content} object={account} onOk={onDelete}/>
  }
}

export default AccountLinnkDelete;



// WEBPACK FOOTER //
// ./src/components/AccountLinnkDelete.js